import { NotificationService } from 'src/app/shared/services/notification.service';
import { RiskanalysisService } from './../services/risk-analysis.service';
import { ActivityServices } from './../services/activities.services';
import { BlurService } from '../../../shared/services/blur.service';

import {
  inject,
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';

import { first } from 'rxjs/operators';
import { BusinessDepartmentService } from './../../business-department.services';
import { Employee } from '../../employees/models/employee';
import { UploaderConfig } from 'src/app/shared/ecpl-document-explorer/uploader-config';
import { HelperService } from 'src/app/_services/helper.service';
import { ConfirmationService } from 'primeng/api';
import { environment } from './../../../../environments/environment';
import { ValidationService } from './../../shared/services/validation.service';

import { BaseServices } from './../../kuba.services';
import { Topic } from '../../safety-job-analysis/models/topic';
import { Department, Deviation, TypeOfCase } from './../models/deviation';
import { DeviationServices } from './../services/deviation.services';
import { CreateDeviationRequestDto, DeviationAttachmentRequest } from '../../deviation/models/createDeviationRequest';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { FeatureKey, Feature } from 'src/app/_models';
import { Rights, Status } from 'src/app/_models';
import { Options } from 'src/app/_models/options';
import { DatePipe } from '@angular/common';
import { Subscription, Observable, pipe } from 'rxjs';
import { tap, finalize, catchError } from 'rxjs/operators';
import { EmployeeServices } from '../../employees/services/employee.services';
import { DateService } from 'src/app/_services/date.service';
import {
  FeatureIdAndKey,
  ModuleObjectDropdownOptionDto
} from '../models/moduleObjectDropdown';

@Component({
  selector: 'deviation',
  templateUrl: 'deviation-new.component.html',
  styleUrls: ['deviation-new.component.scss'],
  standalone: false
})
export class AddDeviationComponent implements OnInit {
  @Input() isEditSubDept: boolean;
  @Input() departmentIdList: number[];
  @Output() subDepModalClosed = new EventEmitter<void>();
  //#region variables
  private readonly notifications = inject(NotificationService);
  deviationForm: FormGroup;
  featureId: number;
  selectedBusinessId: number;
  selectedDept = new Department();
  selectedTypeOfCase = new TypeOfCase();
  selectedTopic = new Topic();
  departments: SelectItem[];
  selectedDepartments: any[] = [];
  TypeOfCases: SelectItem[];
  Topics: SelectItem[];
  selectedTypeCaseId: number;
  editDepts: any = [];
  viewDept = false;
  addtypeOfCase = false;
  addTopic = false;
  viewTopic = false;
  viewTypeOfCase = false;
  editTypeOfCases: any = [];
  editTopics: any = [];
  upConfig: UploaderConfig;
  uploadedFiles: any = [];
  additionalData: any;
  newDocumentAdded: any = [];
  deviationId: number;
  departmentForm: FormGroup;
  caseForm: FormGroup;
  deptId: number;
  deptParentId: string;
  addSubDept: boolean;
  showSubDept: boolean;
  deptName: boolean;
  caseId: number;
  topicForm: FormGroup;
  topicId: number;
  addDept: boolean;
  SubDepartmentForm: FormGroup;
  isDepartmentNameExists: boolean;
  existsDepartmentAlerttext: string;
  existsTypeCaseAlerttext: string;
  isTypeCaseNameExists: boolean;
  isTopicNameExists: boolean;
  existsTopicAlerttext: string;
  loading: boolean;
  saveAndCreateNewLoading: boolean;
  isHideGuest = true;
  businessFeature: Feature[];
  SendonlytoDepartment: boolean;
  IsClear = false;

  haveModules = false;
  moduleDropdown: SelectItem<FeatureIdAndKey>[] = [];

  // Portal-related properties
  isPortal: boolean = false;
  selectedBusinessName: string = '';
  showBusinessSelectionDialog: boolean = false;
  departmentList: any = [];
  private subscriptions: Subscription[] = [];

  /**
   * A deviation is created as New, or registered as already handled. Open and Rejected are
   * reachable only from the edit screen, which is why this is a two-option subset of the
   * status group shown there.
   */
  statusOptions = [new Options(Status.New, 'NEW'), new Options(Status.Done, 'DONE')];

  showMore = false;
  importances: SelectItem[];
  currentDeadLine: Date;
  currentDate: Date;
  executions: SelectItem[];
  followUps: SelectItem[];
  followUpNotify: any;
  followLabel: any;
  execLabel: any;
  selectedFollowup: string;
  isAddNewEmployee = true;
  hideSaveUserButton: boolean;
  assignedDepartments: any[] = [];
  subDepartmentsList: any[] = [];
  IsHidden = true;
  departmentValue: number[];
  subDepartmentPopup: FormGroup;
  subDeptId: number;
  departmentCreator: number;
  AddSubDepartmentloading = false;
  existsAlerttext: string;
  isNameExists: boolean;
  editSubDepartments: any;
  SubDepartment: any = [];
  viewSubDept = false;
  selectedSubDept: any[] = [];
  isNewForm = true;
  minDate!: Date;
  activatedFeatureIds: number[] = [];
  //#endregion
  //#region constructor
  /**
   * constructor
   * @param activatedRoute {ActivatedRoute}
   * @param _fb {FormBuilder}
   * @param deviationService {DeviationServices}
   * @param location {Location}
   * @param confirmationService {ConfirmationService}
   */
  constructor(
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private deviationService: DeviationServices,
    protected location: Location,
    private confirmationService: ConfirmationService,
    private riskAnalysisServices: RiskanalysisService,
    private businessDepartmentService: BusinessDepartmentService,
    private translate: TranslateService,
    private datePipe: DatePipe,
    public employeeServices: EmployeeServices,
    private activityServices: ActivityServices,
    private router: Router,
    private blurService: BlurService,
    private dateService: DateService
  ) {
    this.deviationForm = this._fb.group({
      Title: ['', Validators.required],
      Description: [''],
      Status: [Status.New],
      TypeCase: ['', [Validators.required]],
      Department: ['', [Validators.required]],
      SubDepartment: [''],
      Topic: ['', [Validators.required]],
      ModuleObject: [null],
      showUser: [''],
      Browse: [''],
      SendOnlyDepartment: [''],
      SendonlytoEditors: [0],
      ImmediateAction: [''],
      EventLocation: [''],
      EventDate: [''],
      EventTime: [''],
      Importance: [''],
      Cost: [null],
      Deadline: [null],
      Execution: [null],
      Followup: [null],
      CauseAnalysis: [''],
      CorrectiveAction: [''],
      EffectOfAction: [''],
      Comment: [''],
      Notification: [null, [], this.notificationdays.bind(this)],
      FollowupNotification: [null]
    });
    this.departmentForm = this._fb.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.SubDepartmentForm = this._fb.group({
      SubDepartment: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator]
      ]
    });
    this.caseForm = this._fb.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.topicForm = this._fb.group({
      Name: ['', [Validators.required, ValidationService.noWhitespaceValidator]]
    });
    this.subDepartmentPopup = this._fb.group({
      SubDepartment: [
        '',
        [Validators.required, ValidationService.noWhitespaceValidator]
      ],
      BusinessDepartment: ['']
    });
    if (+BaseServices.roleId === 4) {
      this.isHideGuest = false;
    }
    let currentUserRole = BaseServices.UserRole;
    let userRightsId = Rights.ADMINISTRATE_DEVIATION;
    if (+BaseServices.roleId === 5) {
      this.isHideGuest = BaseServices.checkUserRights(
        userRightsId,
        currentUserRole
      );
    }
  }
  //#endregion
  //#region page-events
  /**
   * bind dropdowns
   */
  ngOnInit(): void {
    this.activatedFeatureIds = window.history.state?.activatedFeatureIds ?? [];
    this.featureId = FeatureKey.FOLLOW_UP;
    this.initializePortalMode();
    document.querySelector('body').classList.remove('opened');
    this.minDate = new Date();
    this.minDate.setHours(0, 0, 0, 0);
    this.revalidateNotificationOnDeadlineChange();
    this.deptName = false;
    this.additionalData = {
      ApplicationId: BaseServices.ApplicationId,
      BusinessId: this.selectedBusinessId
        ? this.selectedBusinessId
        : BaseServices.BusinessId,
      ParentId: 0,
      Status: '1',
      CreatedOn: new Date(),
      ModifiedBy: BaseServices.UserId,
      ModifiedOn: new Date()
    };
    let docList = this.activatedRoute.snapshot.data['doclist'];
    if (docList && docList.length > 0) {
      this.uploadedFiles = this.activatedRoute.snapshot.data['doclist'];
    }

    this.bindDropDowns();
    this.bindImportanceDropdown();
    this.bindFormDropdown();
    this.bindModuleObjectDropdown();

    // Subscribe to deadline changes
    this.deviationForm.get('Deadline')?.valueChanges.subscribe(value => {
      if (value) {
        this.currentDeadLine = new Date(value);
        this.currentDate = new Date();
        this.deviationForm['controls']['Notification'].setValue(0);
      }
    });

    // Subscribe to event date changes
    this.deviationForm.get('EventDate')?.valueChanges.subscribe(value => {
      if (value) {
        this.enableClear();
      }
    });

    // Handle SubDepartment disabled state
    if (this.hideSaveUserButton) {
      this.deviationForm.get('SubDepartment')?.disable();
    } else {
      this.deviationForm.get('SubDepartment')?.enable();
    }

    this.upConfig = {
      title: 'DEVIATION_DOCUMENT',
      titleAsLabel: true,
      editMode: true,
      windowedHeight: false,
      viewSwitch: false,
      showUserMeta: false,
      showSearchFilter: false,
      showUploadButton: true,
      showDeleteButton: true,
      uploaderUri:
        environment.BASE_URL + '/file/upload/business/followup/deviation-docs',
      addtionalData: this.additionalData
    };
    if (this.isEditSubDept != null) {
      this.isNewForm = false;
      this.addSubDept = this.isEditSubDept;
      if (this.departmentIdList != null && this.departmentIdList.length > 0) {
        this.bindSubDepartments(this.departmentIdList);
      }
    }
  }
  //#endregion

  /**
   * file upload events
   * @param event {any}
   */
  saveUploaded(event: any) {
    if (event) {
      let eventType = event.eventName;
      let keyBindings = {
        Originalname: 'OriginalFileName',
        FileTypeId: 'FileType'
      };
      let deviationDoc = Object.assign({}, event, this.additionalData);
      switch (eventType) {
        case 'DeleteDefaultFile':
          this.uploadedFiles = this.uploadedFiles.filter(
            (x: any) => x.path !== event.item.data.path
          );
          if (event.item.data.id === 0) {
            this.newDocumentAdded = this.newDocumentAdded.filter(
              (x: any) => x.Path !== event.item.data.path
            );
          } else {
            deviationDoc.id = event.item.data.id;
            deviationDoc.createdBy = BaseServices.UserId;
            deviationDoc.status = 2;
            this.newDocumentAdded.push(
              HelperService.switchKeysCase(deviationDoc, keyBindings)
            );
          }
          break;
        default:
          deviationDoc.id = 0;
          deviationDoc.createdBy = BaseServices.UserId;
          deviationDoc.status = 1;
          this.newDocumentAdded.push(
            HelperService.switchKeysCase(deviationDoc, keyBindings)
          );
          break;
      }
    }
  }

  //#region control-events

  /**
   * Builds a reusable RxJS operator pipeline shared by all deviation save calls.
   *
   * On success, triggers the toast notification.
   * On both completion and error, clears the appropriate loading flag:
   * `saveAndCreateNewLoading` when saving and creating a new record, otherwise `loading`.
   * Errors are re-thrown after the loading state is cleared.
   *
   * @param useSaveAndCreateNewLoading - When `true`, clears `saveAndCreateNewLoading`; otherwise clears `loading`.
   * @returns A composed RxJS operator ready to be passed directly to `.pipe()`.
   */
  private saveDeviationPipe(useSaveAndCreateNewLoading: boolean) {
    const clearLoading = () => {
      if (useSaveAndCreateNewLoading) {
        this.saveAndCreateNewLoading = false;
      } else {
        this.loading = false;
      }
    };
    return pipe(
      tap((isDeviationAdded: boolean) => {
        if (isDeviationAdded) {
          this.notifications.success('UI_NOTIFICATIONS.SAVED');
        }
      }),
      finalize(clearLoading),
      catchError(error => {
        clearLoading();
        throw error;
      })
    );
  }

  /**
   * Builds and submits a new deviation from the current form values.
   *
   * Sets the appropriate loading flag before submission, then maps all form
   * fields onto a `Deviation` model. If a `ModuleObject` is selected, the
   * deviation is linked to that module via `addDeviationForModule`; otherwise
   * it is saved as a standalone follow-up deviation via `addDeviation`.
   * The resulting observable is piped through {@link saveDeviationPipe} to
   * handle toast notification and loading-flag teardown.
   *
   * @param useSaveAndCreateNewLoading - When `true`, uses `saveAndCreateNewLoading`
   *   instead of `loading` as the in-flight indicator, allowing "Save & create new"
   *   and the regular save button to have independent loading states.
   * @returns An `Observable<boolean>` that emits `true` when the deviation was
   *   successfully persisted.
   */
  saveDeviation(
    useSaveAndCreateNewLoading: boolean = false
  ): Observable<boolean> {
    if (useSaveAndCreateNewLoading) {
      this.saveAndCreateNewLoading = true;
    } else {
      this.loading = true;
    }
    let windowOrigin = window.location.origin;
    let applicationBase = '';
    let appSettings = JSON.parse(sessionStorage.getItem('appSettings')!);
    if (appSettings) {
      applicationBase = appSettings.BaseUrl;
    }
    let usersettings = JSON.parse(sessionStorage.getItem('userSettings')!);
    if (usersettings) {
      this.businessFeature = <Feature[]>(
        JSON.parse(usersettings.userFeature.Features)
      );
      usersettings = this.businessFeature.find(
        record => record.id === FeatureKey.FOLLOW_UP
      );
      if (usersettings.children) {
        let feature = usersettings.children.find(
          (data: any) => data.id === FeatureKey.SEND_ONLY_TO_DEPARTMENT
        );
        this.SendonlytoDepartment = feature ? feature.checked : false;
      }
    }
    var businessId = this.selectedBusinessId
      ? this.selectedBusinessId
      : BaseServices.BusinessId;
    let url =
      windowOrigin +
      '/' +
      applicationBase +
      '/login?returnUrl=' +
      '/app/business/' +
      businessId +
      '/follow-up/deviations/edit/';
    const departmentValues = this.deviationForm.value.Department;
    const businessDepartmentIds: number[] = Array.isArray(departmentValues)
      ? departmentValues.map((dept: any) =>
          typeof dept === 'object' && dept.value !== undefined ? dept.value : dept
        )
      : departmentValues;

    const isModule = this.deviationForm.value.ModuleObject != null;
    const featureId: number = isModule
      ? this.deviationForm.value.ModuleObject.FeatureId
      : this.featureId;
    const featureKey: number | undefined = isModule
      ? this.deviationForm.value.ModuleObject.FeatureKey
      : undefined;

    const request: CreateDeviationRequestDto = {
      Title: this.deviationForm.value.Title,
      BusinessDepartmentIds: businessDepartmentIds,
      TopicId: this.deviationForm.value.Topic,
      CaseId: this.deviationForm.value.TypeCase,
      FeatureId: featureId,
      FeatureKey: featureKey,
      BusinessId: businessId,
      Status: this.deviationForm.value.Status,
      SubDepartmentId: this.deviationForm.value.SubDepartment,
      Description: this.deviationForm.value.Description,
      EventDate: this.deviationForm.value.EventDate
        ? this.dateService.formatDateToString(this.deviationForm.value.EventDate)
        : undefined,
      EventTime: this.deviationForm.value.EventTime
        ? HelperService.formatTime(this.deviationForm.value.EventTime)
        : undefined,
      EventLocation: this.deviationForm.value.EventLocation,
      ImmediateAction: this.deviationForm.value.ImmediateAction,
      Deadline: this.deviationForm.value.Deadline
        ? this.dateService.formatDateToString(this.deviationForm.value.Deadline)
        : undefined,
      Importance: this.deviationForm.value.Importance,
      Cost: this.deviationForm.value.Cost,
      CauseAnalysis: this.deviationForm.value.CauseAnalysis,
      CorrectiveAction: this.deviationForm.value.CorrectiveAction,
      EffectOfAction: this.deviationForm.value.EffectOfAction,
      Comment: this.deviationForm.value.Comment,
      ExecutionUserId: this.deviationForm.value.Execution,
      FollowupUserId: this.deviationForm.value.Followup,
      NotifyBeforeDeadLine: this.deviationForm.value.Notification,
      NotificationBeforeFollowup: this.deviationForm.value.FollowupNotification,
      DeviationAttachments: (this.newDocumentAdded ?? []).map(
        (a: any): DeviationAttachmentRequest => ({
          Filename: a.Filename,
          OriginalFileName: a.OriginalFileName,
          MimeType: a.MimeType,
          Size: a.Size,
          Path: a.Path,
          FileType: a.FileType,
          Status: a.Status
        })
      )
    };

    return this.deviationService
      .createDeviation(request)
      .pipe(this.saveDeviationPipe(useSaveAndCreateNewLoading));
  }

  /**
   * save and update department
   */
  saveDepartment() {
    let department = new Department();
    if (this.showSubDept) {
      this.deptParentId += this.deptId;
      this.deptId = 0;
      department.Name = this.SubDepartmentForm.value.SubDepartment;
    } else {
      department.Name = this.departmentForm.value.Name;
    }
    department.Id = this.deptId ? this.deptId : 0;
    department.Status = 1;
    department.BusinessId = this.selectedBusinessId
      ? this.selectedBusinessId
      : BaseServices.BusinessId;
    department.ApplicationId = BaseServices.ApplicationId;
    department.ParentId = this.deptParentId ? this.deptParentId : '';
    if (department.Id > 0) {
      department.ModifiedBy = BaseServices.UserId;
      this.clearCachedDepartment();
      this.subscriptions.push(
        this.deviationService
          .updateDepartment(department.Id, department)
          .subscribe(isDeptUpdated => {
            if (isDeptUpdated) {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshDepartmentDropDown(
                isDeptUpdated.Id,
                isDeptUpdated.name
              );
              this.addDept = false;
            } else {
              this.existsDepartmentAlerttext =
                this.translate.instant(`TOPIC_EXIST`);
              this.isDepartmentNameExists = true;
              setTimeout(() => {
                this.isDepartmentNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      this.clearCachedDepartment();
      department.CreatedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.deviationService
          .addDepartment(department)
          .subscribe(isDeptAdded => {
            if (isDeptAdded) {
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.refreshDepartmentDropDown(isDeptAdded.Id, isDeptAdded.name);
              this.addDept = false;
            } else {
              this.existsDepartmentAlerttext =
                this.translate.instant(`TOPIC_EXIST`);
              this.isDepartmentNameExists = true;
              setTimeout(() => {
                this.isDepartmentNameExists = false;
              }, 3000);
            }
          })
      );
    }
  }
  /**
   * cache clear of department
   */
  clearCachedDepartment() {
    this.businessDepartmentService.clearCachedAllDepartment();
  }
  /**
   * save type of case
   */
  saveTypeOfCase() {
    let typeOfcase = new TypeOfCase();
    typeOfcase.Id = this.caseId ? this.caseId : 0;
    typeOfcase.Name = this.caseForm.value.Name;
    typeOfcase.BusinessId = this.selectedBusinessId
      ? this.selectedBusinessId
      : BaseServices.BusinessId;
    typeOfcase.ApplicationId = BaseServices.ApplicationId;
    typeOfcase.Status = '1';
    if (typeOfcase.Id > 0) {
      this.subscriptions.push(
        this.deviationService
          .updateCaseType(typeOfcase.Id, typeOfcase)
          .subscribe(isTypeUpdated => {
            if (isTypeUpdated) {
              this.addtypeOfCase = false;
              this.notifications.success('UI_NOTIFICATIONS.SAVED');
              this.bindTypeCaseDropDown();
              this.deviationForm.get('TypeCase')!.patchValue(isTypeUpdated.Id);
            } else {
              this.existsTypeCaseAlerttext =
                this.translate.instant(`TOPIC_EXIST`);
              this.isTypeCaseNameExists = true;
              setTimeout(() => {
                this.isTypeCaseNameExists = false;
              }, 3000);
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.deviationService.addTypeCase(typeOfcase).subscribe(isTypeSaved => {
          if (isTypeSaved) {
            this.addtypeOfCase = false;
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.deviationService.clearCachedCaseType();
            this.bindTypeCaseDropDown();
            this.deviationForm.get('TypeCase')!.patchValue(isTypeSaved.Id);
          } else {
            this.existsTypeCaseAlerttext =
              this.translate.instant(`TOPIC_EXIST`);
            this.isTypeCaseNameExists = true;
            setTimeout(() => {
              this.isTypeCaseNameExists = false;
            }, 3000);
          }
        })
      );
    }
  }
  /**
   * save topic
   */
  saveTopic() {
    let topic = new Topic();
    topic.Id = this.topicId ? this.topicId : 0;
    topic.Name = this.topicForm.value.Name;
    topic.Status = '1';
    topic.BusinessId = this.selectedBusinessId
      ? this.selectedBusinessId
      : BaseServices.BusinessId;
    if (topic.Id > 0) {
      this.subscriptions.push(
        this.deviationService.updateTopics(topic).subscribe(isTopicUpdated => {
          if (isTopicUpdated) {
            this.addTopic = false;
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.fetchTopic();
            this.deviationForm.get('Topic')!.patchValue(isTopicUpdated.Id);
          } else {
            this.existsTopicAlerttext = this.translate.instant(`TOPIC_EXIST`);
            this.isTopicNameExists = true;
            setTimeout(() => {
              this.isTopicNameExists = false;
            }, 3000);
          }
        })
      );
    } else {
      this.subscriptions.push(
        this.deviationService.addTopics(topic).subscribe(isTopicAdded => {
          if (isTopicAdded) {
            this.addTopic = false;
            this.notifications.success('UI_NOTIFICATIONS.SAVED');
            this.riskAnalysisServices.clearCachedTopic();
            this.fetchTopic();
            this.deviationForm.get('Topic')!.patchValue(isTopicAdded.Id);
          } else {
            this.existsTopicAlerttext = this.translate.instant(`TOPIC_EXIST`);
            this.isTopicNameExists = true;
            setTimeout(() => {
              this.isTopicNameExists = false;
            }, 3000);
          }
        })
      );
    }
    this.selectedTopic = new Topic();
  }
  /**
   * department popup reset
   */
  onBeforeDeptDialogHide() {
    this.departmentForm.reset();
    this.deptId = 0;
    this.deptParentId = '';
    this.addSubDept = false;
    this.showSubDept = false;
    this.deptName = false;
    if (this.isEditSubDept) {
      this.closeSubDepartmentModal();
    }
  }
  /**
   * case popup reset
   */
  onBeforeCaseDialogHide() {
    this.caseForm.reset();
    this.caseId = 0;
  }
  /**
   * topic popup reset
   */
  onBeforeTopicDialogHide() {
    this.topicForm.reset();
    this.topicId = 0;
  }

  //#endregion
  //#region methods
  /**
   * go to list
   */
  gotoList() {
    this.location.back();
  }

  /**
   * bind all dropdowns
   */
  bindDropDowns() {
    this.bindDepartmentDropDown();
    this.TypeOfCases = [];
    this.subscriptions.push(
      this.translate
        .stream('SELECT_DROPDOWN')
        .pipe(first())
        .subscribe(val => {
          this.TypeOfCases = [];
          this.TypeOfCases.push({ label: val.SELECT, value: null });
          this.editTypeOfCases = [];

          // Get data from the new resolver structure
          let businessData = this.activatedRoute.snapshot.data['businessData'];
          let typeOfCases =
            businessData?.caseType ||
            this.activatedRoute.snapshot.data['caseType'];

          if (typeOfCases) {
            typeOfCases.forEach((element: any) => {
              this.TypeOfCases.push({ label: element.Name, value: element.Id });
              this.editTypeOfCases.push({ Name: element.Name, Id: element.Id });
            });
          }
        })
    );

    this.editTopics = [];
    this.Topics = [];
    this.subscriptions.push(
      this.translate
        .stream('SELECT_DROPDOWN')
        .pipe(first())
        .subscribe(val => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });

          // Get data from the new resolver structure
          let businessData = this.activatedRoute.snapshot.data['businessData'];
          let topics =
            businessData?.topic || this.activatedRoute.snapshot.data['topic'];

          if (topics) {
            topics.forEach((element: any) => {
              this.Topics.push({ label: element.Name, value: element.Id });
              this.editTopics.push({ Name: element.Name, Id: element.Id });
            });
          }
        })
    );
  }

  /**
   * bind department dropdown
   */
  bindDepartmentDropDown() {
    this.departments = [];
    this.editDepts = [];

    // Get data from the new resolver structure
    let businessData = this.activatedRoute.snapshot.data['businessData'];
    let departments =
      businessData?.department ||
      this.activatedRoute.snapshot.data['department'];

    if (departments) {
      this.departmentDropDown(departments);
    }
  }
  /**
   * common dropdown bind
   * @param departments {any}
   */
  departmentDropDown(departments: any) {
    let department = _.filter(departments, { ParentId: null });
    department = _.orderBy(department, ['Name'], ['asc', 'desc']);
    this.departments = [];
    this.editDepts = [];
    this.subscriptions.push(
      this.translate
        .stream('SELECT_DROPDOWN')
        .pipe(first())
        .subscribe(val => {
          this.departments = [];
          this.departments.push();
          if (department) {
            department.forEach((department: any) => {
              this.departments.push({
                label: department.Name,
                value: department.Id
              });
              this.editDepts.push({
                Name: department.Name,
                Id: department.Id,
                BusinessId: department.BusinessId || 0
              });
              if (department.Id) {
                let subDepartment = _.filter(departments, {
                  ParentId: department.Id
                });
                subDepartment.forEach((subDept: Department) => {
                  this.departments.push({
                    label: `${department.Name} (${subDept.Name})`,
                    value: subDept.Id
                  });
                  this.editDepts.push({
                    Name: `${department.Name} (${subDept.Name})`,
                    Id: subDept.Id,
                    BusinessId: subDept.BusinessId || 0
                  });
                });
              }
            });
          }
        })
    );
    if (department) {
      return true;
    }
    return false;
  }

  /**
   * Populates the `moduleDropdown` list from route resolver data.
   *
   * Reads the pre-fetched `moduleDropdown` array from the activated route snapshot,
   * prepends a null "SELECT" placeholder entry, then appends one `SelectItem` per
   * `ModuleObjectDropdownOptionDto` — mapping `Name` to `label` and `Feature`
   * (a `FeatureIdAndKey` object) to `value`.
   *
   * Sets `haveModules` to `true` when at least one module object is available,
   * which controls the visibility of the ModuleObject dropdown in the template.
   */
  bindModuleObjectDropdown() {
    const moduleObjects = this.activatedRoute.snapshot.data['moduleDropdown'];

    this.moduleDropdown.push({
      label: this.translate.instant('SELECT'),
      value: null
    });
    if (moduleObjects && moduleObjects.length > 0) {
      moduleObjects.forEach((element: ModuleObjectDropdownOptionDto) => {
        if (this.activatedFeatureIds.includes(element.Feature.FeatureId)) {
          this.moduleDropdown.push({
            label: element.Name,
            value: element.Feature
          });
        }
      });
      this.haveModules = true;
    }
  }

  onDepartmentDropDownChanged(departmentDropdown: any) {
    this.IsHidden = false;
    this.departmentValue = departmentDropdown.value;
    this.assignSubDepartmentDropdown(this.departmentValue);
    this.bindSubDepartments(this.departmentValue);
  }

  onBeforeSubDepartmentDialogHide() {
    this.subDepartmentPopup.reset();
    this.subDeptId = 0;
  }
  editSubDept(empSubDept: any) {
    this.subDeptId = empSubDept.Id;
    this.departmentCreator = empSubDept.CreatedBy;
    this.subDepartmentPopup = this._fb.group({
      SubDepartment: empSubDept.Name
    });
  }
  deleteSubDept(empSubdept: any) {
    if (empSubdept.busId > 0 || empSubdept.BusinessId > 0) {
      this.confirmationService.confirm({
        message: this.translate.instant('DELETE_THIS_RECORD'),
        accept: () => {
          this.subscriptions.push(
            this.employeeServices
              .deleteSubDepartment(empSubdept.Id)
              .subscribe(isDocumentDeleted => {
                if (isDocumentDeleted) {
                                       this.notifications.success('UI_NOTIFICATIONS.DELETED');
                  // this.bindSubDepartment(this.departmentValue);
                }
              })
          );
        }
      });
    }
  }

  saveSubDept() {
    this.AddSubDepartmentloading = true;
    let employeeSubDept = new Employee();
    employeeSubDept.Id = this.subDeptId ? this.subDeptId : 0;
    employeeSubDept.Name = this.subDepartmentPopup.value.SubDepartment;
    employeeSubDept.Status = '1';
    employeeSubDept.BusinessId = this.selectedBusinessId
      ? this.selectedBusinessId
      : BaseServices.BusinessId;
    employeeSubDept.ApplicationId = BaseServices.ApplicationId;
    employeeSubDept.BusinessDeptId =
      this.subDepartmentPopup.value.BusinessDepartment;
    if (employeeSubDept.Id > 0) {
      employeeSubDept.ModifiedBy = BaseServices.UserId;
      employeeSubDept.CreatedBy = this.departmentCreator;
      this.subscriptions.push(
        this.employeeServices
          .updateDept(employeeSubDept)
          .subscribe(updatedSubDept => {
            this.bindSubDeptDropdown(updatedSubDept);
            this.AddSubDepartmentloading = false;
          })
      );
    } else {
      employeeSubDept.CreatedBy = BaseServices.UserId;
      this.subscriptions.push(
        this.employeeServices
          .createSubDept(employeeSubDept)
          .subscribe(addedSubdept => {
            this.bindSubDeptDropdown(addedSubdept);
            this.AddSubDepartmentloading = false;
          })
      );
    }
  }

  bindSubDeptDropdown(subDeptInfo: any) {
    if (subDeptInfo) {
      this.addSubDept = false;
      this.notifications.success('UI_NOTIFICATIONS.SAVED');
      this.bindSubDepartments(subDeptInfo.BusinessDeptId);
      this.deviationForm.get('SubDepartment')!.patchValue(subDeptInfo.Id);
    } else {
      this.existsAlerttext = this.translate.instant(`TOPIC_EXIST`);
      this.isNameExists = true;
      setTimeout(() => {
        this.isNameExists = false;
      }, 3000);
    }
  }

  bindSubDepartments(value: number[]) {
    this.subscriptions.push(
      this.employeeServices
        .getAllSubDepartments(value)
        .subscribe((subDepartment: any) => {
          this.subDepartmentsList = [];
          subDepartment.forEach((element: any) => {
            if (subDepartment) {
              this.subDepartmentsList.push({
                label: element.Name,
                value: element.Id
              });
            }
            this.editSubDepartments = subDepartment;
          });
        })
    );
  }
  assignSubDepartmentDropdown(value: number[]) {
    this.assignedDepartments = [];
    this.assignedDepartments.push({
      label: this.translate.instant('SELECT'),
      value: null
    });
    this.subscriptions.push(
      this.employeeServices
        .getAssignedDepartments(value)
        .subscribe(subDepartment => {
          this.SubDepartment = subDepartment;
          if (subDepartment) {
            this.SubDepartment.forEach((element: any) => {
              if (this.assignedDepartments) {
                this.assignedDepartments.push({
                  label: element.Name,
                  value: element.Id
                });
              }
            });
          }
        })
    );
  }
  /**
   * bind type department dropdown
   */
  refreshDepartmentDropDown(departmentId: number, departmentname: any[]) {
    if (this.selectedBusinessId) {
      this.subscriptions.push(
        this.businessDepartmentService
          .getDepartmentsByBusinessId(this.selectedBusinessId)
          .subscribe(deptDropDown => {
            this.departmentList = deptDropDown;
            if (deptDropDown) {
              let isUpdated = this.departmentDropDown(deptDropDown);
              if (isUpdated) {
                this.deviationForm.get('Department')!.patchValue(departmentId);
                this.selectedDepartments = departmentname;
              }
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.businessDepartmentService
          .getCachedBusinessDepartment()
          .subscribe(deptDropDown => {
            this.departmentList = deptDropDown;
            if (deptDropDown) {
              let isUpdated = this.departmentDropDown(deptDropDown);
              if (isUpdated) {
                this.deviationForm.get('Department')!.patchValue(departmentId);
                this.selectedDepartments = departmentname;
              }
            }
          })
      );
    }
  }
  /**
   * bind department dropdown
   */
  bindDepartment() {
    this.editDepts = [];

    if (this.selectedBusinessId) {
      this.subscriptions.push(
        this.businessDepartmentService
          .getDepartmentsByBusinessId(this.selectedBusinessId)
          .subscribe(res => {
            if (res) {
              this.editDepts = res;
            }
          })
      );
    } else {
      this.subscriptions.push(
        this.businessDepartmentService
          .getCachedBusinessDepartment()
          .subscribe(res => {
            if (res) {
              this.editDepts = res;
            }
          })
      );
    }
  }
  /**
   * bind type case dropdown
   */
  bindTypeCaseDropDown() {
    if (this.selectedBusinessId) {
      this.subscriptions.push(
        this.deviationService
          .getAllCaseTypeByBusinessId(
            this.selectedBusinessId
              ? this.selectedBusinessId
              : BaseServices.BusinessId
          )
          .subscribe(caseDropDown => {
            this.TypeOfCases = [];
            this.subscriptions.push(
              this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
                this.TypeOfCases = [];
                this.TypeOfCases.push({ label: val.SELECT, value: null });
                caseDropDown.forEach((element: any) => {
                  this.TypeOfCases.push({
                    label: element.Name,
                    value: element.Id
                  });
                });
                this.editTypeOfCases = caseDropDown;
              })
            );
          })
      );
    } else {
      this.subscriptions.push(
        this.deviationService.getAllCaseType().subscribe(caseDropDown => {
          this.TypeOfCases = [];
          this.subscriptions.push(
            this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
              this.TypeOfCases = [];
              this.TypeOfCases.push({ label: val.SELECT, value: null });
              caseDropDown.forEach((element: any) => {
                this.TypeOfCases.push({
                  label: element.Name,
                  value: element.Id
                });
              });
              this.editTypeOfCases = caseDropDown;
            })
          );
        })
      );
    }
  }

  /**
   * bind topic dropdown
   */
  bindTopicDropDown() {
    let topic = this.activatedRoute.snapshot.data['deviationTopic'];
    if (topic) {
      this.Topics = [];
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.Topics = [];
          this.Topics.push({ label: val.SELECT, value: null });
          topic.forEach((element: any) => {
            this.Topics.push({ label: element.Name, value: element.Id });
          });
          this.editTopics = topic;
        })
      );
    }
  }
  checkDeptValid() {
    if (this.showSubDept) {
      this.deptName = true;
      if (this.SubDepartmentForm.status === 'INVALID') {
        return true;
      }
    } else if (this.departmentForm.status === 'INVALID') {
      return true;
    }
    return false;
  }
  /**
   * edit department
   * @param Dept {{any}}
   */
  editDept(Dept: any) {
    this.showSubDept = false;
    let departments: any = [];
    departments = this.activatedRoute.snapshot.data['department'];
    if (departments) {
      departments = this.departmentList.filter((x: any) => x.Id === Dept.Id);
    }
    this.deptId = Dept.Id;
    this.deptParentId = departments[0].ParentId;
    if (this.deptParentId === null) {
      this.addSubDept = true;
    } else {
      this.addSubDept = false;
    }
    let department = {
      Name: departments[0].Name
    };
    (<FormGroup>this.departmentForm).setValue(department, { onlySelf: true });
  }

  addSubDepartment() {
    this.addSubDept = false;
    this.showSubDept = true;
  }
  /**
   * Check if user can delete department based on role and BusinessId
   * @param department Department to check
   * @returns boolean indicating if deletion is allowed
   */
  canDeleteDepartment(department: any): boolean {
    const roleId = +BaseServices.roleId;
    const restrictedRoles = [3, 4, 5]; // Editor, Guest, User

    // If BusinessId is 0 and user has restricted role, cannot delete
    if (department.BusinessId === 0 && restrictedRoles.includes(roleId)) {
      return false;
    }
    return true;
  }

  /**
   * delete department
   * @param deleteType {{any}}
   */
  deleteDept(deleteType: any) {
    // Check if user has permission to delete this department
    if (!this.canDeleteDepartment(deleteType)) {
      this.notifications.add({ severity: 'error', summary: this.translate.instant('NO_PERMISSION'), detail: this.translate.instant('NO_PERMISSION_TO_DELETE_THIS_DEPARTMENT') });
      return;
    }

    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService
            .deleteDepartment(deleteType.Id)
            .subscribe(res => {
              if (res) {
                this.departments = this.departments.filter(
                  department => department.value !== deleteType.Id
                );

                this.bindDepartment();
                this.clearCachedDepartment();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              }
            })
        );
      }
    });
  }

  /**
   * edit type of case
   * @param TypeOfCase {{any}}
   */
  editTypeOfCase(typeOfCase: any) {
    this.caseId = typeOfCase.Id;
    let Case = {
      Name: typeOfCase.Name
    };
    (<FormGroup>this.caseForm).setValue(Case, { onlySelf: true });
  }

  /**
   * delete type of case
   * @param deleteTypeId {{number}}
   */
  deleteTypeOfCase(deleteTypeId: number) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService.deleteTypeCase(deleteTypeId).subscribe(res => {
            if (res) {
              this.bindTypeCaseDropDown();
              this.deviationService.clearCachedCaseType();
              this.notifications.success('UI_NOTIFICATIONS.DELETED');
            }
          })
        );
      }
    });
  }
  /**
   * Fetch the topics
   */
  fetchTopic() {
    this.isTopicNameExists = false;
    this.subscriptions.push(
      this.deviationService
        .getAllTopics(
          this.selectedBusinessId
            ? this.selectedBusinessId
            : BaseServices.BusinessId
        )
        .subscribe((topic: any) => {
          this.subscriptions.push(
            this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
              this.Topics = [];
              this.Topics.push({ label: val.SELECT, value: null });
              if (topic) {
                topic.forEach((topicValue: any) => {
                  this.Topics.push({
                    label: topicValue.Name,
                    value: topicValue.Id
                  });
                });
              }
            })
          );
          this.editTopics = topic;
        })
    );
  }

  /**
   * edit topic
   * @param Topic {{any}}
   */
  editTopic(topic: any) {
    this.topicId = topic.Id;
    let topicControl = {
      Name: topic.Name
    };
    (<FormGroup>this.topicForm).setValue(topicControl, { onlySelf: true });
  }

  /**
   * delete type of topic
   * @param deleteTopic {{any}}
   */
  deleteTopic(deleteTopic: any) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.subscriptions.push(
          this.deviationService
            .deleteTopics(deleteTopic)
            .subscribe(isTopicDeleted => {
              if (isTopicDeleted) {
                this.fetchTopic();
                this.riskAnalysisServices.clearCachedTopic();
                this.notifications.success('UI_NOTIFICATIONS.DELETED');
              }
            })
        );
      }
    });
  }

  /**
   * get current date
   */
  getCurrentDate() {
    return new Date();
  }

  /**
   * bind evnet date and time
   */
  bindEventDate() {
    let dateFormat = new Date();
    this.deviationForm.controls['EventDate'].setValue(new Date());
    this.deviationForm.controls['EventTime'].setValue(
      this.datePipe.transform(dateFormat, 'HH:mm')
    );
    this.IsClear = true;
  }

  /**
   * clear evnet date and time
   */
  clearEventDate() {
    this.deviationForm.controls['EventDate'].setValue(null);
    this.deviationForm.controls['EventTime'].setValue(null);
    this.IsClear = false;
  }

  /**
   * enable clear button
   */
  enableClear() {
    this.IsClear = true;
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }

  bindImportanceDropdown() {
    this.subscriptions.push(
      this.translate.stream('RISKFIGURE_DROPDOWN').subscribe(val => {
        this.importances = [];
        this.importances.push(
          { label: val.SELECT, value: null },
          { label: val.LOW, value: 1 },
          { label: val.MEDIUM, value: 2 },
          { label: val.HIGH, value: 3 }
        );
      })
    );
  }

  /**
   * cost key press event
   * @param e {e}
   * @param limitNumber {limitNumber}
   */
  onNumber(e: any, limitNumber: any) {
    const limit = limitNumber;
    const dots = e.target.value.indexOf('.');
    let charCode = e.which ? e.which : e.keyCode;
    if (
      e.target.value.length === limit ||
      dots > 1 ||
      (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46)
    ) {
      e.preventDefault();
    }
  }

  onDeadLineChanged(event: any) {
    // PrimeNG calendar passes the selected date directly in the event
    if (event) {
      this.currentDeadLine = new Date(event);
    } else {
      this.currentDeadLine = null;
    }
    this.currentDate = new Date();
    this.deviationForm['controls']['Notification'].setValue(0);
  }

  onEventDateChanged(event: any) {
    // PrimeNG calendar passes the selected date directly in the event
    if (event) {
      this.enableClear();
    }
  }

  bindFormDropdown() {
    let responsiblePerson = this.activatedRoute.snapshot.data['user'];
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.executions = [];
        this.executions.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((followupExecution: any) => {
            this.executions.push({
              label: followupExecution.Name,
              value: this.isPortal
                ? followupExecution.ContactPersonId
                : followupExecution.Id
            });
          });
        }
      })
    );
    this.subscriptions.push(
      this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
        this.followUps = [];
        this.followUps.push({ label: val.SELECT, value: null });
        if (responsiblePerson) {
          responsiblePerson.forEach((followupExecution: any) => {
            this.followUps.push({
              label: followupExecution.Name,
              value: this.isPortal
                ? followupExecution.ContactPersonId
                : followupExecution.Id
            });
          });
        }
      })
    );

    this.followUpNotify = [];
    for (let n = 0; n <= 14; n++) {
      if (n === 0) {
        this.followUpNotify.push({
          label: this.translate.instant('ON_DEADLINE_DATE'),
          value: n
        });
      } else {
        this.followUpNotify.push({ label: n.toString(), value: n });
      }
    }
    this.followUpNotify.push(
      { label: this.translate.instant('TREE_WEEKS'), value: 21 },
      { label: this.translate.instant('ONE_MONTH'), value: 30 }
    );
  }

  /**
   * followup dropdown change event
   * @param e
   * @param followupDropdown
   */

  onFollowChanged(e: any, follow: any) {
    if (e.value) {
      this.followLabel = follow.selectedOption.label;
    }
  }

  /**
   * execution dropdown change eventF
   * @param e
   * @param executionDropdown
   */

  onExecChanged(e: any, exec: any) {
    if (e.value) {
      this.execLabel = exec.selectedOption.label;
    }
  }

  /**
   * The reminder is sent `Notification` days before the deadline. A value reaching further back
   * than today can never be delivered, so it is rejected here as well as by the backend.
   *
   * The span is signed on purpose: a deadline already in the past leaves no valid value at all,
   * and an absolute difference would quietly accept one.
   */
  notificationdays(control: FormControl) {
    return new Promise(resolve => {
      const deadline = this.deviationForm?.get('Deadline')?.value;
      if (control.value === null || control.value === undefined || !deadline) {
        resolve(null);
        return;
      }

      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const deadlineDate = new Date(deadline);
      deadlineDate.setHours(0, 0, 0, 0);

      const ONE_DAY = 1000 * 60 * 60 * 24;
      const daysUntilDeadline = Math.round(
        (deadlineDate.getTime() - today.getTime()) / ONE_DAY
      );

      resolve(control.value > daysUntilDeadline ? { notificationdays: true } : null);
    });
  }

  /**
   * An async validator only re-runs when its own control changes, so moving the deadline has to
   * re-check the notification day count explicitly.
   */
  private revalidateNotificationOnDeadlineChange() {
    const deadline = this.deviationForm.get('Deadline');
    if (!deadline) {
      return;
    }
    this.subscriptions.push(
      deadline.valueChanges.subscribe(() =>
        this.deviationForm.get('Notification')?.updateValueAndValidity()
      )
    );
  }

  /**
   * A completed deviation has nothing left to remind anyone about, so both notification fields
   * are disabled. A disabled control drops out of `form.value`, which is what clears the stored
   * days - leaving them would keep a reminder that can never be sent.
   */
  private syncNotificationFields(status: number) {
    const notification = this.deviationForm.get('Notification');
    const followupNotification = this.deviationForm.get('FollowupNotification');

    if (status === Status.Done) {
      notification?.reset();
      notification?.disable();
      followupNotification?.reset();
      followupNotification?.disable();
    } else {
      notification?.enable();
      followupNotification?.enable();
    }
  }

  /**
   * Registering a deviation as already handled puts it under the same rules as pressing
   * "Manage deviation now": the four fields below become required, so the section is opened.
   * Going back to New closes it again - but only when nothing has been entered there, since
   * closing clears the block and the user would lose what they had filled in.
   */
  onStatusChange(option: Options) {
    this.syncNotificationFields(option.id);

    if (option.id === Status.Done) {
      // Open the block so the handling can still be recorded, but leave the four optional
      this.toggleManageNow(true);
      this.setManageFieldsRequired(false);
    } else if (this.hasManageData()) {
      this.setManageFieldsRequired(true);
    } else {
      this.toggleManageNow(false);
    }
  }

  /**
   * True when any field in the manage block holds a value. The controls stay in the form group
   * while the section is hidden, so their values survive a close and can be read here.
   */
  private hasManageData(): boolean {
    const form = this.deviationForm.value;
    return [
      form.Deadline,
      form.Importance,
      form.Execution,
      form.Followup,
      form.Cost,
      form.CauseAnalysis,
      form.CorrectiveAction,
      form.EffectOfAction,
      form.Comment,
      form.Notification,
      form.FollowupNotification
    ].some(value => value !== null && value !== undefined && value !== '');
  }

  /**
   * The four manage fields are required together, or not at all. A completed deviation is the
   * exception: it records how the deviation was handled rather than who is going to handle it,
   * and it has no reminder that a missing responsible user could break - so there the same four
   * fields are optional. The backend applies the same exception.
   */
  private setManageFieldsRequired(required: boolean) {
    for (const name of ['Importance', 'Deadline', 'Execution', 'Followup']) {
      const control = this.deviationForm.controls[name];
      if (!control) {
        continue;
      }
      if (required) {
        control.setValidators(Validators.required);
      } else {
        control.clearValidators();
      }
      control.updateValueAndValidity();
    }
  }

  toggleManageNow(isShowMore: boolean) {
    if (isShowMore == true) {
      this.showMore = true;
      this.setManageFieldsRequired(this.deviationForm.value.Status !== Status.Done);
    } else {
      this.showMore = false;
      // Done is only reachable while the manage block is in use - closing it reverts the status
      this.deviationForm.controls['Status'].patchValue(Status.New);
      this.syncNotificationFields(Status.New);
      this.deviationForm.controls['Department'].setValidators(
        Validators.required
      );
      this.deviationForm.controls['Department'].updateValueAndValidity();
      this.deviationForm.controls['Topic'].setValidators(Validators.required);
      this.deviationForm.controls['Topic'].updateValueAndValidity();
      this.deviationForm.controls['TypeCase'].setValidators(
        Validators.required
      );
      this.deviationForm.controls['TypeCase'].updateValueAndValidity();
      this.deviationForm.controls['Title'].setValidators(Validators.required);
      this.deviationForm.controls['Title'].updateValueAndValidity();

      this.setManageFieldsRequired(false);
      this.deviationForm.controls['Followup'].reset();
      this.deviationForm.controls['Execution'].reset();
      this.deviationForm.controls['Deadline'].reset();
      this.deviationForm.controls['Importance'].reset();
    }
  }

  //#endregion

  closeSubDepartmentModal() {
    this.subDepModalClosed.emit();
  }

  /**
   * Initialize portal-specific mode
   */
  private initializePortalMode(): void {
    this.isPortal = BaseServices.roleId === '2';
    if (this.isPortal) {
      const businessName = this.activatedRoute.snapshot.queryParams['Name'];
      const businessId = this.activatedRoute.snapshot.queryParams['Id'];
      if (businessId) {
        this.selectedBusinessId = parseInt(businessId);
      }
      if (businessName) {
        this.selectedBusinessName = businessName;
      } else {
        this.selectedBusinessName = 'Business Not Found';
      }
    }
  }

  /**
   * Handle regular save button click
   */
  onSaveClick(): void {
    // Check if form is valid before saving
    if (this.deviationForm.valid) {
      this.subscriptions.push(
        this.saveDeviation().subscribe({
          next: () => {
            this.gotoList();
          },
          error: error => {
            // Error handling is already done in saveDeviation method
          }
        })
      );
    } else {
      // Mark all fields as touched to show validation errors
      this.deviationForm.markAllAsTouched();
    }
  }

  /**
   * Save deviation and create new
   */
  saveAndCreateNew(): void {
    if (this.deviationForm.valid) {
      this.subscriptions.push(
        this.saveDeviation(true).subscribe({
          next: () => {
            // Reset form for new deviation
            this.resetFormForNewDeviation();
            // Show business selection dialog and enable blur
            this.showBusinessSelectionDialog = true;
            this.blurService.enableBlur();
          },
          error: error => {
            // Error handling is already done in saveDeviation method
          }
        })
      );
    }
  }

  /**
   * Handle business selection from dialog
   */
  onBusinessSelected(businessData: { id: number; name: string }): void {
    this.showBusinessSelectionDialog = false;
    this.blurService.disableBlur();

    // Update the selected business data
    this.selectedBusinessId = businessData.id;
    this.selectedBusinessName = businessData.name;

    // Clear all cached data to force fresh API calls
    this.clearAllCachedData();

    // Reload the component data manually
    this.reloadComponentData();
  }

  /**
   * Clear all cached data to force fresh API calls
   */
  private clearAllCachedData(): void {
    // Clear department cache
    this.businessDepartmentService.clearCachedAllDepartment();

    // Clear topic cache
    this.riskAnalysisServices.clearCachedTopic();

    // Clear case type cache
    this.deviationService.clearCachedCaseType();
  }

  /**
   * Reload component data with new business ID
   */
  private reloadComponentData(): void {
    // Reload departments
    this.businessDepartmentService
      .getCachedBusinessDepartmentByBusinessId(this.selectedBusinessId)
      .subscribe(departments => {
        this.departmentDropDown(departments);
      });

    // Reload topics
    this.riskAnalysisServices
      .getTopicByBusiness(this.selectedBusinessId)
      .subscribe(topics => {
        this.Topics = [];
        this.subscriptions.push(
          this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
            this.Topics = [];
            this.Topics.push({ label: val.SELECT, value: null });
            if (topics) {
              topics.forEach((topic: any) => {
                this.Topics.push({ label: topic.Name, value: topic.Id });
              });
            }
          })
        );
      });

    // Reload case types
    this.deviationService
      .getAllCaseTypeByBusinessId(this.selectedBusinessId)
      .subscribe(caseTypes => {
        this.TypeOfCases = [];
        this.subscriptions.push(
          this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
            this.TypeOfCases = [];
            this.TypeOfCases.push({ label: val.SELECT, value: null });
            if (caseTypes) {
              caseTypes.forEach((caseType: any) => {
                this.TypeOfCases.push({
                  label: caseType.Name,
                  value: caseType.Id
                });
              });
            }
          })
        );
      });

    // Reload users
    this.deviationService.getUser(this.selectedBusinessId).subscribe(users => {
      this.executions = [];
      this.followUps = [];
      this.subscriptions.push(
        this.translate.stream('SELECT_DROPDOWN').subscribe(val => {
          this.executions = [];
          this.executions.push({ label: val.SELECT, value: null });
          this.followUps = [];
          this.followUps.push({ label: val.SELECT, value: null });
          if (users) {
            users.forEach((user: any) => {
              this.executions.push({
                label: user.Name,
                value: this.isPortal ? user.ContactPersonId : user.Id
              });
              this.followUps.push({
                label: user.Name,
                value: this.isPortal ? user.ContactPersonId : user.Id
              });
            });
          }
        })
      );
    });
  }

  /**
   * Handle business selection cancellation
   */
  onBusinessSelectionCancelled(): void {
    this.showBusinessSelectionDialog = false;
    this.blurService.disableBlur();
  }

  /**
   * Reset form for new deviation
   */
  private resetFormForNewDeviation(): void {
    this.deviationForm.reset();
    this.uploadedFiles = [];

    // reset() clears every control, so the status the form opens with has to be put back
    this.deviationForm.get('Status').patchValue(Status.New);
  }
}
